import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PublicLayout from "./layout/PublicLayout";
import PageIndex from "./pages/PageIndex";
import About from "./pages/about/About";
import MenuBarProvider from "./contexts/MenuBarContext";
import ResizingProvider from "./contexts/ResizingContext";
import Page404 from "./pages/Page404/Page404";
import ServiceLayout from "./pages/servicesPages/ServiceLayout";
import Contact from "./pages/contact/Contact";
import Faq from "./pages/faq/Faq";
import TermsAndCondition from "./pages/terms/TermsAndCondition";
import PrivacyPolicy from "./pages/terms/PrivacyPolicy";
import TestimonialsNew from "./pages/testimonials/TestimonialsNew";
import { Provider } from "react-redux";
import { store } from "./redux/storeConfig";
import ScrollToTop from "./components/ScrollToTop";

// ✅ Import the LoadingAnimation component
import LoadingAnimation from "./components/LoadingAnimation"; // adjust path as necessary

function App() {
  const [isLoading, setIsLoading] = useState(true); // Initial loading state

  useEffect(() => {
    // Simulate loading for 2 seconds or until actual data is ready
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500); // You can tweak this delay

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingAnimation />;
  }

  return (
    <MenuBarProvider>
      <ResizingProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Provider store={store}>
            <Routes>
              <Route
                path={`${process.env.PUBLIC_URL}/`}
                element={<PublicLayout />}
              >
                <Route index element={<PageIndex />} />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/home`}
                  element={<PageIndex />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/about`}
                  element={<About />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/contact`}
                  element={<Contact />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/testimonials`}
                  element={<TestimonialsNew />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/faq`}
                  element={<Faq />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/terms-and-conditions`}
                  element={<TermsAndCondition />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/privacy-policy`}
                  element={<PrivacyPolicy />}
                />
                <Route path="/services/:id" element={<ServiceLayout />} />
              </Route>

              {/* Error 404 Page */}
              <Route path="*" element={<Page404 />} />
            </Routes>
          </Provider>
        </BrowserRouter>
      </ResizingProvider>
    </MenuBarProvider>
  );
}

export default App;
